import { getSnowplowEnv, getSnowplowUserData } from '@/utils/analytics/analytics-utils';
import { SNOWPLOW } from '@/utils/analytics/constants';
import { KAMELEOON, VISITOR_CODE_COOKIE_NAME } from '@/utils/kameleoon/constants';
import { useEffect, useRef, useState } from 'react';
import { useKameleoonFlagsClient } from '@/hooks/use-kameleoon-flags-client';
import UniversalCookies from 'universal-cookie';

const { CUSTOM_DATA } = KAMELEOON;
const Cookies = new UniversalCookies();

const setKameleoonCustomData = () => {
  window.kameleoonQueue = window.kameleoonQueue || [];
  const { Kameleoon, kameleoonQueue } = window as any;
  const snowplowUser = getSnowplowUserData();
  const visitorCode = Cookies.get(VISITOR_CODE_COOKIE_NAME);

  if (visitorCode) {
    kameleoonQueue.push({
      level: 'IMMEDIATE',
      command: () => Kameleoon.API.Visitor.setVisitorCode(visitorCode),
    });
  }

  const snowplowEnv = getSnowplowEnv().toUpperCase() as 'QA' | 'DEV' | 'PROD';

  const cleanedSPObj = Object.fromEntries(
    //@ts-expect-error -- global window stuff
    Object.entries(window.__SHL__.getState().shopping_experience)
      .filter(([k, v]) => k === "banner" || v !== null)
  );
  const customContext = JSON.stringify({
    schema: "iglu:co.loblawdigital/shopping_experience/jsonschema/1-0-1",
    data: cleanedSPObj
  });

  //Setting the custom data required by snowplow
  kameleoonQueue.push(function () {
    Kameleoon.API.Data.setCustomData(CUSTOM_DATA.SP_APP_ID, SNOWPLOW.APP_ID[snowplowEnv]);
    Kameleoon.API.Data.setCustomData(CUSTOM_DATA.SP_DOMAIN_USERID, snowplowUser.domainUserId);
    Kameleoon.API.Data.setCustomData(CUSTOM_DATA.SP_ID_CROSS_DEVICE, snowplowUser.domainUserId);
    Kameleoon.API.Data.setCustomData(CUSTOM_DATA.SP_DOMAIN_SESSIONID, snowplowUser.sessionId);
    Kameleoon.API.Data.setCustomData(CUSTOM_DATA.SP_CUSTOM_CONTEXT, customContext);
  });
};

//Kameleoon is an experimentation tool, hook is used to send custom data to snowplow for tracking
export const useKameleoonEngine = () => {
  const [isSnowplowAndKamReady, setIsSnowplowAndKamReady] = useState(false);
  const [checkForKamEngine, setCheckForKamEngine] = useState(false);
  const attemptCountRef = useRef(0);

  // Use the new Kameleoon flags client hook (waits for cookie)
  // warehouseKey will be the same as visitorCode for anonymous users
  useKameleoonFlagsClient({ visitorCodeCookieName: VISITOR_CODE_COOKIE_NAME });

  useEffect(() => {
    if (!isSnowplowAndKamReady) {
      const shlReady = Object.keys(window?.__SHL__?.getState()?.shopping_experience || {}).length > 0;
      if (typeof window !== 'undefined' && window.Kameleoon && shlReady) {
        setIsSnowplowAndKamReady(true);
        // Allow only 5 checks (every 1s) to avoid infinite loop if Kameleoon script never loads
      } else if (attemptCountRef.current < 4) {
        attemptCountRef.current += 1;
        setTimeout(() => setCheckForKamEngine((prev) => !prev), 1000);
      }
    }
  }, [checkForKamEngine, isSnowplowAndKamReady]);

  useEffect(() => {
    if (isSnowplowAndKamReady) {
      setKameleoonCustomData();
    }
  }, [isSnowplowAndKamReady]);

  return {
    isSnowplowAndKamReady
  };
};
